export default {
  accepted: 'Хүлээн авсан',
  accessRequestDate: 'Нэвтрэх хүсэлт гаргасан огноо',
  confirmUserWillBeSystemAdmin: 'Хэрэглэгч систем администратор болно. Үргэлжлүүлэх үү?',
  copyInvitationLink: 'Урилгын холбоосыг санах ойд хуулах',
  copyInvitationLinkConfirmMessage: `Хэрэв уригдсан хэрэглэгч {{email}} хаяг руу имэйл хүлээн аваагүй бол,
та урилгын холбоосыг санах ойд хуулаад түүнтэй өөр аргаар хуваалцах боломжтой.

Урилгын холбоосыг санах ойд хуулах уу?`,
  copyPasswordResetLink: 'Нууц үг сэргээх холбоосыг санах ойд хуулах уу?',
  passwordResetLinkCopiedToClipboard: 'Нууц үг сэргээх холбоосыг санах ойд хуулсан',
  passwordResetLink: 'Нууц үг сэргээх холбоос',
  copyPasswordResetLinkConfirmMessage: `Хэрэв хэрэглэгч нууц үгээ сэргээсэн боловч {{email}} хаяг руу имэйл хүлээн аваагүй бол,
та нууц үг сэргээх холбоосыг санах ойд хуулаад түүнтэй өөр аргаар хуваалцах боломжтой.

Нууц үг сэргээх холбоосыг санах ойд хуулах уу?`,
  editSurveyUserExtraPropsForUser: 'Хэрэглэгч "{{userName}}"-ийн судалгааны нэмэлт шинж чанаруудыг засах',
  inviteUser: 'Урих',
  invitationExpiredClickToSendAgainTheInvitation: 'Урилга дууссан: урилгыг дахин илгээхийн тулд дарна уу',
  invitationLinkCopiedToClipboard: 'Урилгын холбоосыг таны санах ойд хуулсан',
  invitedBy: 'Урьсан',
  invitedDate: 'Урьсан огноо',
  lastLogin: 'Сүүлийн нэвтрэлт',
  moreThan30DaysAgo: '30 гаруй хоногийн өмнө',
  notAcceptedYet: 'Урилгыг хараахан хүлээн аваагүй байна',
  prefs: {
    title: 'Мэдэгдлийн тохиргоо',
    notifyOnUserAccessRequest: 'Шинэ хэрэглэгчийн хандалтын хүсэлт',
  },
  roleInCurrentSurvey: 'Одоогийн судалгаан дахь үүрэг',
  roleInSurvey: 'Судалгаан дахь үүрэг',
  filterPlaceholder: 'Нэр эсвэл имэйлээр шүүх',
  surveyName: 'Судалгааны нэр',
  surveyExtraProp: {
    label: 'Судалгааны нэмэлт шинж чанар',
    label_other: 'Судалгааны нэмэлт шинж чанарууд',
  },
  surveysDraft: 'Судалгаанууд (ноорог)',
  surveysPublished: 'Судалгаанууд (нийтлэгдсэн)',
  userRemovedFromSurveyGoToSurveysRequired: `Та энэ судалгаанаас хасагдсан байна.  
Судалгааны жагсаалтыг нээхийн тулд Судалгааны жагсаалт руу очих товчийг дарна уу.`,
  userRoleUpdatedRefreshRequired: `Таны энэ судалгаан дахь үүрэг шинэчлэгдлээ.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Шинэ бүлэг',
    edit: 'Бүлэг засах',
    name: 'Нэр',
    label: 'Шошго',
    qualifier: 'Тодотгол {{index}}',
    qualifier_plural: 'Тодотголууд',
    qualifierKey: 'Түлхүүр',
    qualifierValue: 'Утга',
    addQualifier: 'Тодотгол нэмэх',
    members: 'Гишүүд',
    addMember: 'Гишүүн нэмэх',
    noMembers: 'Гишүүн байхгүй байна',
    memberAlreadyInGroup: '"{{groupName}}" бүлэгт байна',
    tabs: {
      groups: 'Хэрэглэгчийн бүлгүүд',
      assignments: 'Гишүүдийн хуваарилалт',
      report: 'Гишүүдийн тайлан',
    },
    memberName: 'Гишүүний нэр',
    memberEmail: 'Гишүүний имэйл',
    memberRole: 'Судалгаан дахь үүрэг',
    memberStatus: 'Төлөв',
    status: {
      INVITED: 'Урьсан',
      ACCEPTED: 'Хүлээн авсан',
      FORCE_CHANGE_PASSWORD: 'Нууц үг солих шаардлагатай',
    },
    unassigned: 'Хуваарилагдаагүй',
    confirmDelete: '"{{name}}" бүлгийг устгах уу? Гишүүд нь хуваарилагдаагүй болно. Үргэлжлүүлэх үү?',
    deleteConfirmed: '"{{name}}" бүлэг устгагдлаа',
    saveConfirmed: '"{{name}}" бүлэг хадгалагдлаа',
    confirmReassign: '{{userName}} одоогоор "{{groupName}}" бүлэгт байна. Үүний оронд энэ бүлэгт шилжүүлэх үү?',
    notFound: 'Бүлэг олдсонгүй',
  },
  updateUserConfirmation: 'Хэрэглэгч {{name}} шинэчлэгдсэн',
  userNotInvitedToAnySurvey: `Хэрэглэгчийг ямар ч судалгаанд уриагүй байна`,
  userSurveys: 'Хэрэглэгчийн судалгаанууд',
  usersBackup: {
    menu: 'Нөөцлөх / Сэргээх',
    backup: 'Хэрэглэгчдийг нөөцлөх',
    backupTitle: 'Хэрэглэгчдийг нөөцлөх',
    backupInfo:
      'Бүх хэрэглэгчийг судалгаан дахь үүрэг болон хэрэглэгчийн бүлгүүдийн хамт экспортлох бөгөөд өөр Arena сервер рүү сэргээх боломжтой. 2FA төхөөрөмжүүдийг экспортлохгүй.',
    includePasswords: 'Нууц үгийг оруулах',
    passwordsWarning: 'Нөөц файлд нууц үгийн хэшүүд агуулагдана: аюулгүй газар хадгалж, ашигласны дараа устгана уу.',
    restore: 'Хэрэглэгчдийг сэргээх',
    restoreTitle: 'Нөөцөөс хэрэглэгчдийг сэргээх',
    restoreInfo: `- Хэрэглэгчдийг имэйлээр нь тааруулна
- Судалгаан дахь үүрэг болон хэрэглэгчийн бүлгүүдийг судалгааны нэр болон бүлгийн нэрээр тааруулна
- Энэ серверт байхгүй судалгаануудын үүрэг болон хэрэглэгчийн бүлгүүдийг үл тооно
- "Хэрэглэгчдийг сэргээх"-ийг дарсны дараа хэрэглэгч бүрт юу хийхийг сонгох боломжтой`,
    backupFileInfo: '{{email}} {{date}}-нд үүсгэсэн нөөц (сервер: {{serverUrl}})',
    passwordsNotIncluded: 'Энэ нөөцөд нууц үг ороогүй: шинэ хэрэглэгчид нууц үгээ сэргээх шаардлагатай',
    allNewUsers: 'Бүх шинэ хэрэглэгчид ({{count}})',
    allExistingUsers: 'Бүх байгаа хэрэглэгчид ({{count}})',
    userStatus: 'Төлөв',
    userActionHeader: 'Үйлдэл',
    userNew: 'Шинэ',
    userExisting: 'Байгаа',
    userAction: {
      insert: 'Нэмэх',
      skip: 'Алгасах',
      updateRoles: 'Судалгааны үүргийг шинэчлэх',
      updateAll: 'Судалгааны үүрэг болон мэдээллийг шинэчлэх',
    },
    sysAdmin: 'Сист. админ',
    restorePassword: 'Нууц үг',
    restorePasswordInfo:
      'Нөөцөд хадгалагдсан нууц үгийг сэргээх (зөвхөн хэрэглэгчийг нэмэх эсвэл мэдээллийг шинэчлэх үед)',
    userActionShort: {
      insert: 'Нэмэх',
      skip: 'Алгасах',
      updateRoles: 'Үүрэг',
      updateAll: 'Үүрэг + мэдээлэл',
    },
    details: {
      survey: 'Судалгаа',
      roleInBackup: 'Нөөц дэх үүрэг',
      currentRole: 'Одоогийн үүрэг',
      notFoundInThisServer: '(энэ серверт олдсонгүй)',
      userGroup: 'Хэрэглэгчийн бүлэг',
      inBackup: 'Нөөцөд',
      currentMember: 'Одоогийн гишүүн',
    },
    summaryImported: 'Хэрэглэгчдийг сэргээлээ',
    summary: {
      usersTotal: 'Нөөц дэх хэрэглэгчид: {{count}}',
      usersInserted: 'Шинэ хэрэглэгчид: {{count}}',
      usersUpdated: 'Шинэчлэгдсэн хэрэглэгчид: {{count}}',
      usersSkipped: 'Алгассан хэрэглэгчид: {{count}}',
      authGroupsAdded: 'Нэмэгдсэн судалгааны үүрэг: {{count}}',
      userGroupsAdded: 'Нэмэгдсэн хэрэглэгчийн бүлгийн гишүүнчлэл: {{count}}',
    },
    surveysNotFound: 'Олдоогүй судалгаанууд (үүргийг үл тоосон): {{names}}',
    userGroupsNotFound: 'Олдоогүй хэрэглэгчийн бүлгүүд (гишүүнчлэлийг үл тоосон): {{names}}',
  },
}
